import LocalizedLink from '@/components/layout/LocalizedLink'
import { ChevronRight, ChevronLeft } from 'lucide-react'
import Button from '@/components/ui/Button'
import { type Surah } from './SurahCard'
import { useTranslation } from 'react-i18next'

interface SurahNavigationProps {
  previousSurah: Surah | null
  nextSurah: Surah | null
}

export default function SurahNavigation({ previousSurah, nextSurah }: SurahNavigationProps) {
  const { t } = useTranslation()

  return (
    <div className="flex items-center justify-between gap-4 pt-6 border-t border-gray-200 dark:border-gray-700">
      {previousSurah ? (
        <LocalizedLink to={`/quran/${previousSurah.id}`}>
          <Button variant="secondary" className="flex items-center gap-2">
            <ChevronRight className="w-4 h-4" />
            <div className="text-right">
              <p className="text-xs text-gray-500 dark:text-gray-400">{t('common.previous', 'السابق')}</p>
              <p className="font-medium">{previousSurah.name}</p>
            </div>
          </Button>
        </LocalizedLink>
      ) : (
        <div></div>
      )}

      {nextSurah && (
        <LocalizedLink to={`/quran/${nextSurah.id}`}>
          <Button variant="secondary" className="flex items-center gap-2">
            <div className="text-start">
              <p className="text-xs text-gray-500 dark:text-gray-400">{t('common.next', 'التالي')}</p>
              <p className="font-medium">{nextSurah.name}</p>
            </div>
            <ChevronLeft className="w-4 h-4" />
          </Button>
        </LocalizedLink>
      )}
    </div>
  )
}


